module.exports = __webpack_public_path__ + "e0a9ebf96373d502b21ac521e5942e9c.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/locations/virginia.png
// module id = 3272
// module chunks = 69